import { render, staticRenderFns } from "./GpCheckbox.vue?vue&type=template&id=04af8c7e&scoped=true&"
import script from "./GpCheckbox.vue?vue&type=script&lang=js&"
export * from "./GpCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./GpCheckbox.vue?vue&type=style&index=0&id=04af8c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af8c7e",
  null
  
)

export default component.exports